import { render, staticRenderFns } from "./BtnUpdateArticleList.vue?vue&type=template&id=27fe9448&scoped=true&"
import script from "./BtnUpdateArticleList.vue?vue&type=script&lang=js&"
export * from "./BtnUpdateArticleList.vue?vue&type=script&lang=js&"
import style0 from "./BtnUpdateArticleList.vue?vue&type=style&index=0&id=27fe9448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe9448",
  null
  
)

export default component.exports